module.exports = __webpack_public_path__ + "img/8.d4c1134c.svg";